var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.94 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-mark { fill: #3D7DDD; }\n      .cls-word { fill: #F4F7FB; }\n      .cls-mid { fill: #0082CA; }\n      .cls-light { fill: #5FD0DF; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-mark",
    d: "M12.59,7.31V35.16a14.52,14.52,0,0,0,7.25,12.56L138.1,116V79.77Z",
    transform: "translate(-12.59 -7.31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-word",
    d: "M170.72,87.37H157.27v7.88h10.29V98H157.27v9.67h13.92v2.73h-17V84.64h16.49Z",
    transform: "translate(-12.59 -7.31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-word",
    d: "M193.84,110.81h-1.09L181.56,84.64H185l8.35,20.17,8.34-20.17H205Z",
    transform: "translate(-12.59 -7.31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-word",
    d: "M219.61,110.38h-3V84.64h3Z",
    transform: "translate(-12.59 -7.31)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-word",
    points: "230.85 76.91 229.76 76.91 218.57 103.08 221.81 103.08 225.12 95.12 230.31 82.53 235.41 95.12 238.77 103.08 242.04 103.08 230.85 76.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-word",
    d: "M278,99.23a7,7,0,0,0,5.46-7.14,7.54,7.54,0,0,0-.58-3,6.92,6.92,0,0,0-1.66-2.36,7.53,7.53,0,0,0-2.59-1.54,10.26,10.26,0,0,0-3.44-.55h-9v25.74h3v-23h5.89a5.25,5.25,0,0,1,3.9,1.35,4.67,4.67,0,0,1,1.32,3.41A4.57,4.57,0,0,1,279,95.54a5.32,5.32,0,0,1-3.9,1.31h-2.42l10.06,13.53h3.55Z",
    transform: "translate(-12.59 -7.31)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-word",
    d: "M314.06,87.37H300.61v7.88H310.9V98H300.61v9.67h13.92v2.73h-17V84.64h16.49Z",
    transform: "translate(-12.59 -7.31)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-mid",
    d: "M49.38,131h-.06a3.54,3.54,0,0,1-1.74.47,3.6,3.6,0,0,1-2-.61h0l29.79,17.2h0l0,0a7.27,7.27,0,0,0,7.21,0L138.15,116V79.77Z",
    transform: "translate(-12.59 -7.31)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-light",
    d: "M47.58,131.48a3.54,3.54,0,0,0,1.74-.47h.06l26-15V79.77L51.27,93.69A14.51,14.51,0,0,0,44,106.26v21.66h0a3.54,3.54,0,0,0,1.51,2.9l0,.05h0A3.6,3.6,0,0,0,47.58,131.48Z",
    transform: "translate(-12.59 -7.31)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.0ae20c788152bde739f4bafa5beac105.svg";
export { ForwardRef as ReactComponent };